import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog-body" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "dialog-actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

import { ref } from 'vue'
import { useWorksStore } from '@/store/works'
import { getErrorTitle, getErrorMessage } from '@/helpers/errors'
import DialogUI from '@/components/CommonUI/DialogUI.vue'
import { useGettext } from 'vue3-gettext'
import NotificationUI from '../CommonUI/NotificationUI.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WriterUncontrolledDialog',
  emits: ["writerShareAccepted"],
  setup(__props, { expose: __expose, emit }) {

const { $gettext } = useGettext()
const workStore = useWorksStore()

const dialog = ref<IDialogUI>()
const errorMessage = ref('')
const errorTitle = ref('')
const workId = ref(0)
const writerId = ref(0)
const isLoading = ref(false)



function resetError() {
  errorTitle.value = ''
  errorMessage.value = ''
}

function show(setWorkId: number, setWriterId: number) {
  workId.value = setWorkId
  writerId.value = setWriterId
  dialog.value?.show()
}
function hide() {
  dialog.value?.hide()
  workId.value = 0
  writerId.value = 0
  resetError()
}
async function acceptShare() {
  isLoading.value = true

  try {
    resetError()
    await workStore.acceptShareForWriter(workId.value, writerId.value)

    emit('writerShareAccepted')
    hide()
  } catch (error) {
    errorTitle.value = getErrorTitle(error)
    errorMessage.value = getErrorMessage(error)
  }

  isLoading.value = false
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(DialogUI, {
    ref_key: "dialog",
    ref: dialog,
    size: "medium",
    "data-testid": "ConfirmUncontrolledDialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_unref($gettext)("Accepting shares on this Writer's behalf will mark them as an Uncontrolled Writer.")), 1),
        _createElementVNode("p", null, [
          _createElementVNode("span", {
            innerHTML: _unref($gettext)('Ditto <b>will not claim royalty shares</b> for Uncontrolled Writers and <b>this change is irreversible</b>.')
          }, null, 8, _hoisted_2),
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_unref($gettext)("Are you sure you'd like to proceed?")), 1)
        ])
      ]),
      (errorMessage.value || errorTitle.value)
        ? (_openBlock(), _createBlock(NotificationUI, {
            key: 0,
            title: errorTitle.value,
            message: errorMessage.value
          }, null, 8, ["title", "message"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "full-width",
          type: "button",
          disabled: isLoading.value,
          onClick: acceptShare
        }, [
          _createTextVNode(" Yes, add this Writer as an Uncontrolled Writer ")
        ], 8, _hoisted_4)), [
          [_directive_translate]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "secondary full-width",
          type: "button",
          disabled: isLoading.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (hide()))
        }, [
          _createTextVNode(" No, wait for this Writer to accept their shares ")
        ], 8, _hoisted_5)), [
          [_directive_translate]
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})